//@ts-nocheck
// ScalpXIndicator.ts / ScalpXIndicator.js
//
// Port of PineScript "SHREEJI TECHNO SCALPX PRO" to TradingView PineJS API.
//
// Updates:
// - Dynamically pre-allocates 50 Plot Streams to handle massive trend runs.
// - Tracker table automatically expands.
// - Lines set to Style 8 (Line With Breaks) to ensure they snap cleanly on reversals.
function ScalpXIndicator(PineJS) {
    const MAX_TP_LINES = 50;
    const customPlots = [
        { id: "BuyEntry", type: "shapes" },
        { id: "SellEntry", type: "shapes" },
        { id: "ExitMarker", type: "shapes" },
        { id: "BuyEntryLine", type: "line" },
        { id: "SellEntryLine", type: "line" },
        { id: "StopLine", type: "line" }
    ];
    const customStyles = {
        BuyEntry: { title: "Buy Signal", isHidden: false, plottype: "shape_triangle_up", visible: true, location: "BelowBar", color: "#00C853", size: "small", transparency: 0 },
        SellEntry: { title: "Sell Signal", isHidden: false, plottype: "shape_triangle_down", visible: true, location: "AboveBar", color: "#D50000", size: "small", transparency: 0 },
        ExitMarker: { title: "Close Marker", isHidden: false, plottype: "shape_triangle_down", visible: true, location: "AboveBar", color: "#D50000", size: "small", transparency: 0 },
        // Style 8 ensures lines break cleanly between trades
        // BuyEntryLine: { title: "Entry Price Line", isHidden: false, color: "#2962FF", linewidth: 2, style: 8 },
        BuyEntryLine: {
            title: "Buy Entry",
            color: "#2962FF",
            linewidth: 2,
            style: 8
        },
        SellEntryLine: {
            title: "Sell Entry",
            color: "#D50000",
            linewidth: 2,
            style: 8
        },
        StopLine: { title: "Stop Loss Line", isHidden: false, color: "#787B86", linewidth: 2, style: 8 }
    };
    for (let i = 1; i <= MAX_TP_LINES; i++) {
        customPlots.push({ id: `TP${i}`, type: "line" });
        // TP lines kept dashed (style 2), but will break natively on null outputs
        customStyles[`TP${i}`] = { title: `TP ${i} Line`, isHidden: false, color: "#00BCD4", linewidth: 1, style: 2 };
    }
    return {
        name: "ScalpX Pro",
        metainfo: {
            _metainfoVersion: 52,
            id: "ScalpX@tv-basicstudies-1",
            name: "ScalpX Pro",
            description: "ScalpX Pro",
            shortDescription: "ScalpX Pro",
            is_price_study: true,
            is_hidden_study: false,
            isCustomIndicator: true,
            isTVScript: false,
            isTVScriptStub: false,
            defaults: {
                styles: customStyles,
                inputs: {
                    tradeFilter: "Both",
                    rrStep: 1.0,
                    showEntry: true,
                    showSL: true,
                    showTP: false,
                    show_tracker_table: true,
                    show_disclaimer: true,
                    theme_choice: "Classic Grey",
                    max_targets: 10
                }
            },
            plots: customPlots,
            styles: customStyles,
            inputs: [
                { id: "tradeFilter", group: "Trade Settings", name: "Show Trades (Direction)", type: "text", defval: "Both", options: ["Both", "Long Only", "Short Only"] },
                { id: "rrStep", group: "Trade Settings", name: "Dynamic TP Step (RR)", type: "float", defval: 1.0, min: 0.1, step: 0.1 },
                { id: "showEntry", group: "Trade Settings", name: "Show Entry Line", type: "bool", defval: true },
                { id: "showSL", group: "Trade Settings", name: "Show Stop Line", type: "bool", defval: true },
                { id: "showTP", group: "Trade Settings", name: "Show TP Lines", type: "bool", defval: false },
                { id: "show_tracker_table", group: "Tracker Table", name: "Show Tracker Table", type: "bool", defval: true },
                { id: "show_disclaimer", group: "Disclaimer Settings", name: "Show Disclaimer Overlay", type: "bool", defval: true },
                { id: "theme_choice", group: "Tracker Table", name: "Tracker Theme", type: "text", defval: "Classic Grey", options: ["Classic Grey", "Dark Pro", "Light Minimal", "Neon Cyberpunk", "Ghost (Transparent)"] },
                { id: "max_targets", group: "Tracker Table", name: "Max RR Levels In Table", type: "integer", defval: 10, min: 1 }
            ],
            scriptIdPart: "",
            scriptVersion: "",
            isCustomIndicator: true,
            format: { type: "inherit" }
        },
        constructor: function () {
            const self = this;
            self.smaHighArr = [];
            self.smaCloseArr = [];
            self.smaLowArr = [];
            self.latestBuyAlertHigh = undefined;
            self.latestBuyAlertLow = undefined;
            self.latestBuyAlertBarIndex = undefined;
            self.latestSellAlertHigh = undefined;
            self.latestSellAlertLow = undefined;
            self.latestSellAlertBarIndex = undefined;
            self.justReversed = false;
            self.posDir = 0;
            self.posEntry = undefined;
            self.posStop = undefined;
            self.posRisk = undefined;
            self.posMaxPrice = undefined;
            self.posEntryBar = undefined;
            self.maxTPLinesDrawn = 0;
            self.barIndex = 0;
            self.lastBarTime = null;
            self.buyEntryPlot = undefined;
            self.sellEntryPlot = undefined;
            self.exitMarkerPlot = undefined;
            self.history = [];
            self.buySignalBar = null;
            self.sellSignalBar = null;
            self.breakPreviousTradeOnly = false;
            function trim(arr, max) { while (arr.length > max)
                arr.shift(); }
            const OVERLAY_ID = "scalpx-overlay";
            function themeColors(theme) {
                switch (theme) {
                    case "Dark Pro":
                        return { bg: "rgba(19,23,34,0.95)", border: "rgba(100,100,100,0.4)", txt: "#FFFFFF" };
                    case "Light Minimal":
                        return { bg: "rgba(245,247,250,0.95)", border: "rgba(180,180,180,0.4)", txt: "#1E1E1E" };
                    case "Neon Cyberpunk":
                        return { bg: "rgba(9,14,23,0.95)", border: "rgba(0,255,204,0.5)", txt: "#E0FFF8" };
                    case "Ghost (Transparent)":
                        return { bg: "rgba(0,0,0,0)", border: "rgba(255,255,255,0)", txt: "#FFFFFF" };
                    case "Classic Grey":
                    default:
                        return { bg: "rgba(230,230,230,0.95)", border: "rgba(255,255,255,0.0)", txt: "#1E1E1E" };
                }
            }
            function getChartHost() {
                try {
                    return document.querySelector(".chart-container") ||
                        document.querySelector(".tv-main-pane") ||
                        document.querySelector(".chart-markup-table") ||
                        document.querySelector(".layout__area--center") ||
                        document.body;
                }
                catch (e) {
                    return document.body;
                }
            }
            function renderOverlay() {
                try {
                    if (typeof window === "undefined" || !document || !document.body)
                        return;
                    let el = document.getElementById(OVERLAY_ID);
                    const showTable = self._show_tracker_table;
                    const showDisc = self._show_disclaimer;
                    if (!showTable && !showDisc) {
                        if (el)
                            el.remove();
                        return;
                    }
                    const host = getChartHost();
                    if (!el) {
                        el = document.createElement("div");
                        el.id = OVERLAY_ID;
                        el.style.position = "absolute";
                        el.style.top = "0";
                        el.style.left = "0";
                        el.style.width = "100%";
                        el.style.height = "100%";
                        el.style.pointerEvents = "none";
                        el.style.zIndex = "900";
                        if (host && host !== document.body) {
                            host.style.position = host.style.position || "relative";
                            host.appendChild(el);
                        }
                        else {
                            document.body.appendChild(el);
                        }
                    }
                    const tc = themeColors(self._theme_choice);
                    let html = "";
                    // Tracker Table
                    if (showTable) {
                        let rows = "";
                        if (self.posDir !== 0 && self.posEntry != null) {
                            const sig = self.posDir === 1 ? "▲ LONG" : "▼ SHORT";
                            const sigCol = self.posDir === 1 ? "#00C853" : "#D50000";
                            rows += `<tr><td style="padding:3px 8px;color:${tc.txt};font-size:11px;">Position</td><td style="padding:3px 8px;color:#fff;background:${sigCol};text-align:center;font-weight:bold;font-size:12px;">${sig}</td></tr>`;
                            rows += `<tr><td style="padding:3px 8px;color:${tc.txt};font-size:11px;">Entry Price</td><td style="padding:3px 8px;color:${tc.txt};text-align:center;font-weight:bold;font-size:12px;">${self.posEntry.toFixed(2)}</td></tr>`;
                            rows += `<tr><td style="padding:3px 8px;color:${tc.txt};font-size:11px;">Stop Price</td><td style="padding:3px 8px;color:${tc.txt};text-align:center;font-weight:bold;font-size:12px;">${(self.posStop != null ? self.posStop : 0).toFixed(2)}</td></tr>`;
                            const hit_rr = Math.max(0, (self.maxTPLinesDrawn - 1) * self._rrStep);
                            const max_pts = self.posDir === 1
                                ? (self.posMaxPrice - self.posEntry)
                                : (self.posEntry - self.posMaxPrice);
                            const maxPtsVal = Math.max(0, max_pts || 0);
                            const rrLabelCol = hit_rr > 0 ? "#00C853" : "#D50000";
                            const ptsLabelCol = maxPtsVal > 0 ? "#00C853" : "#D50000";
                            rows += `<tr><td style="padding:3px 8px;color:${tc.txt};font-size:11px;">Max RR</td><td style="padding:3px 8px;color:#fff;background:${rrLabelCol};text-align:center;font-weight:bold;font-size:12px;">1:${hit_rr.toFixed(2)}</td></tr>`;
                            rows += `<tr><td style="padding:3px 8px;color:${tc.txt};font-size:11px;">Max Pts</td><td style="padding:3px 8px;color:#fff;background:${ptsLabelCol};text-align:center;font-weight:bold;font-size:12px;">${maxPtsVal.toFixed(2)}</td></tr>`;
                            // const tpsToShow = Math.max(self._max_targets, self.maxTPLinesDrawn);
                            const tpsToShow = self._max_targets;
                            for (let i = 1; i <= tpsToShow; i++) {
                                if (i > MAX_TP_LINES)
                                    break;
                                const tpPrice = self.posDir === 1
                                    ? self.posEntry + (self.posRisk * i * self._rrStep)
                                    : self.posEntry - (self.posRisk * i * self._rrStep);
                                const hit = i < self.maxTPLinesDrawn;
                                const rowCol = hit ? "#00C853" : tc.txt;
                                ;
                                rows += `<tr><td style="padding:3px 8px;color:${rowCol};font-size:11px;">${hit ? "✓" : " "} Target ${i}</td><td style="padding:3px 8px;color:${rowCol};text-align:center;font-size:12px;">${tpPrice.toFixed(2)} (1:${(i * self._rrStep).toFixed(1)})</td></tr>`;
                            }
                        }
                        else {
                            rows += `<tr><td style="padding:6px 12px;color:#9E9E9E;font-size:12px;font-weight:bold;">WAITING FOR SIGNAL...</td></tr>`;
                        }
                        html += `<div style="position:absolute;top:190px;left:53px;;background:${tc.bg};border:1px solid ${tc.border};border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,0.25);">
              <table style="border-collapse:collapse;">${rows}</table></div>`;
                    }
                    if (showDisc) {
                        const disc = "⚠️ DISCLAIMER & RISK WARNING — For educational/informational purposes only. " +
                            "Trading involves high risk; you could lose your investment. Not financial advice. " +
                            "Developer assumes no liability for losses incurred. Trade at your own risk.";
                        html += `<div style="position:absolute;bottom:12px;left:50%;transform:translateX(-50%);max-width:80%;background:rgba(40,43,54,0.9);border:1px solid rgba(255,255,255,0.2);border-radius:6px;padding:6px 12px;pointer-events:auto;">
              <div style="color:#ffffff;font-size:11px;text-align:center;line-height:1.4;">${disc}</div></div>`;
                    }
                    el.innerHTML = html;
                }
                catch (e) {
                    // ignore overlay render errors
                }
            }
            self._renderOverlay = renderOverlay;
            function f_draw_history_marker(_dir, _entryBar, _exitBar, _entryPrice, _stopPrice, _maxTPLinesDrawn, _maxFavPrice) {
                // const hit_rr = Math.max(0, (_maxTPLinesDrawn - 1) * self._rrStep);
                const hit_rr = Math.max(1, Math.floor((_maxTPLinesDrawn - 1) * self._rrStep));
                const max_pts = _dir === 1 ? (_maxFavPrice - _entryPrice) : (_entryPrice - _maxFavPrice);
                //const max_pts_val = Math.max(0, max_pts);
                const max_pts_val = Math.round(Math.max(0, max_pts));
                const res_txt = "Max RR 1:" + hit_rr.toFixed(2) + " | " + max_pts_val.toFixed(2) + " pts";
                // self.markerLabels = self.markerLabels || [];
                //   self.markerLabels.push({
                //       text: res_txt,
                //       price: _entryPrice,
                //       dir: _dir,
                //       bar: _exitBar
                //   });
                const triangle_col = _dir === 1 ? "#2962FF" : "#D50000";
                //self.history.push({ dir: _dir, bar: _entryBar, entry: _entryPrice, stop: _stopPrice, maxRR: hit_rr, maxPts: max_pts_val, text: res_txt, color: triangle_col });
                self.history.push({
                    dir: _dir,
                    bar: _entryBar,
                    exitBar: _exitBar,
                    entry: _entryPrice,
                    stop: _stopPrice,
                    markerPrice: _entryPrice,
                    markerSignalPrice: _entryPrice,
                    maxRR: hit_rr,
                    maxPts: max_pts_val,
                    text: res_txt,
                    color: triangle_col
                });
                if (typeof window !== "undefined") {
                    window.scalpxHistory = self.history;
                }
            }
            self.main = (ctx, inputCallback) => {
                self._input = inputCallback;
                const tradeFilter = self._input(0) || "Both";
                const rrStep = (typeof self._input(1) === "undefined") ? 1.0 : Number(self._input(1));
                const showEntry = self._input(2) !== false;
                const showSL = self._input(3) !== false;
                const showTP = self._input(4) !== false;
                self._show_tracker_table = self._input(5) !== false;
                self._show_disclaimer = self._input(6) === true;
                self._theme_choice = self._input(7) || "Classic Grey";
                self._max_targets = (typeof self._input(8) === "undefined") ? 10 : Number(self._input(8));
                self._rrStep = rrStep;
                const allowLong = tradeFilter === "Both" || tradeFilter === "Long Only";
                const allowShort = tradeFilter === "Both" || tradeFilter === "Short Only";
                ctx.setMinimumAdditionalDepth(10);
                if (!PineJS || !PineJS.Std || !PineJS.Std.sma) {
                    return new Array(5 + MAX_TP_LINES).fill(null);
                }
                const o = PineJS.Std.open(ctx);
                const h = PineJS.Std.high(ctx);
                const l = PineJS.Std.low(ctx);
                const c = PineJS.Std.close(ctx);
                if (!Number.isFinite(o) || !Number.isFinite(h) || !Number.isFinite(l) || !Number.isFinite(c)) {
                    if (self.buySignalBar != null &&
                        self.barIndex > self.buySignalBar) {
                        self.buyEntryPlot = undefined;
                    }
                    if (self.sellSignalBar != null &&
                        self.barIndex > self.sellSignalBar) {
                        self.sellEntryPlot = undefined;
                    }
                    self.exitMarkerPlot = undefined;
                    return new Array(5 + MAX_TP_LINES).fill(null);
                }
                const highSeries = ctx.new_var(h);
                const closeSeries = ctx.new_var(c);
                const lowSeries = ctx.new_var(l);
                const smaHigh = PineJS.Std.sma(highSeries, 5, ctx);
                const smaClose = PineJS.Std.sma(closeSeries, 5, ctx);
                const smaLow = PineJS.Std.sma(lowSeries, 5, ctx);
                self.smaHighArr.push(smaHigh);
                trim(self.smaHighArr, 20);
                self.smaCloseArr.push(smaClose);
                trim(self.smaCloseArr, 20);
                self.smaLowArr.push(smaLow);
                trim(self.smaLowArr, 20);
                const t = PineJS.Std.time(ctx);
                const isNewBar = t !== self.lastBarTime;
                self.lastBarTime = t;
                if (isNewBar)
                    self.barIndex++;
                const isConfirmed = isNewBar;
                if (self.buySignalBar != null &&
                    self.barIndex > self.buySignalBar) {
                    self.buyEntryPlot = undefined;
                }
                if (self.sellSignalBar != null &&
                    self.barIndex > self.sellSignalBar) {
                    self.sellEntryPlot = undefined;
                }
                // const buyAlertBar = isConfirmed && !isNaN(smaLow) &&
                //     o < smaLow && h < smaLow && l < smaLow && c < smaLow;
                //   const sellAlertBar = isConfirmed && !isNaN(smaHigh) &&
                //     o > smaHigh && h > smaHigh && l > smaHigh && c > smaHigh;
                const validRange = Math.abs(h - l) > 0.01;
                const buyAlertBar = validRange &&
                    isConfirmed &&
                    !isNaN(smaLow) &&
                    o < smaLow &&
                    h < smaLow &&
                    l < smaLow &&
                    c < smaLow;
                const sellAlertBar = validRange &&
                    isConfirmed &&
                    !isNaN(smaHigh) &&
                    o > smaHigh &&
                    h > smaHigh &&
                    l > smaHigh &&
                    c > smaHigh;
                // const buyTrigger = self.latestBuyAlertHigh != null &&
                //   self.barIndex > self.latestBuyAlertBarIndex && h >= self.latestBuyAlertHigh;
                // const sellTrigger = self.latestSellAlertLow != null &&
                //   self.barIndex > self.latestSellAlertBarIndex && l <= self.latestSellAlertLow;
                // for buy/short on same candle fix
                let buyTrigger = self.latestBuyAlertHigh != null &&
                    self.barIndex > self.latestBuyAlertBarIndex &&
                    h >= self.latestBuyAlertHigh;
                let sellTrigger = self.latestSellAlertLow != null &&
                    self.barIndex > self.latestSellAlertBarIndex &&
                    l <= self.latestSellAlertLow;
                // Prevent both sides triggering on same candle
                // if (buyTrigger && sellTrigger) {
                //     if (
                //         self.latestBuyAlertBarIndex >
                //         self.latestSellAlertBarIndex
                //     ) {
                //         sellTrigger = false;
                //     }
                //     else {
                //         buyTrigger = false;
                //     }
                // }
                let newBuyEntry = false;
                let newSellEntry = false;
                let reversalOccurred = false;
                // LONG entry
                if (buyTrigger && self.posDir !== 1) {
                    // Clear opposite pending alert
                    // self.latestSellAlertHigh = undefined;
                    // self.latestSellAlertLow = undefined;
                    // self.latestSellAlertBarIndex = undefined;
                    if (self.posDir === -1) {
                        f_draw_history_marker(self.posDir, self.posEntryBar, self.barIndex, self.posEntry, self.posStop, self.maxTPLinesDrawn, self.posMaxPrice);
                        reversalOccurred = true;
                        // self.justReversed = true;
                        self.breakPreviousTradeOnly = true;
                        //self.exitMarkerPlot = self.posEntry;
                        self.exitMarkerPlot = undefined;
                        // self.exitMarkerPlot = { markerPrice: self.posEntry };
                        //self.history.push({ dir: self.posDir, entry: self.posEntry, stop: self.posStop, maxRR: self.maxTPLinesDrawn, maxPrice: self.posMaxPrice, entryBar: self.posEntryBar, exitBar: self.barIndex });
                        self.posDir = 0;
                        self.posEntry = undefined;
                        self.posStop = undefined;
                        self.posRisk = undefined;
                        self.posEntryBar = undefined;
                        self.posMaxPrice = undefined;
                        self.maxTPLinesDrawn = 0;
                    }
                    if (allowLong && self.posDir === 0) {
                        self.posDir = 1;
                        self.posEntry = self.latestBuyAlertHigh;
                        self.posStop = self.latestBuyAlertLow;
                        self.posRisk = Math.abs(self.posEntry - self.posStop);
                        self.posEntryBar = self.barIndex;
                        self.posMaxPrice = h;
                        self.maxTPLinesDrawn = 1;
                        self.sellEntryPlot = undefined;
                        //self.buyEntryPlot = self.posEntry;
                        self.buySignalBar = self.barIndex;
                        self.buyEntryPlot = self.posEntry;
                        // new ly added for refresh issue
                        renderOverlay();
                        newBuyEntry = true;
                        sellTrigger = false;
                        self.latestBuyAlertHigh = undefined;
                        self.latestBuyAlertLow = undefined;
                        self.latestBuyAlertBarIndex = undefined;
                        self.latestSellAlertHigh = undefined;
                        self.latestSellAlertLow = undefined;
                        self.latestSellAlertBarIndex = undefined;
                    }
                }
                // SHORT entry
                if (sellTrigger && self.posDir !== -1 && !newBuyEntry) {
                    // Clear opposite pending alert
                    // self.latestBuyAlertHigh = undefined;
                    // self.latestBuyAlertLow = undefined;
                    // self.latestBuyAlertBarIndex = undefined;
                    if (self.posDir === 1) {
                        f_draw_history_marker(self.posDir, self.posEntryBar, self.barIndex, self.posEntry, self.posStop, self.maxTPLinesDrawn, self.posMaxPrice);
                        reversalOccurred = true;
                        // self.justReversed = true;
                        self.breakPreviousTradeOnly = true;
                        //self.exitMarkerPlot = self.posEntry;
                        self.exitMarkerPlot = undefined;
                        //self.history.push({ dir: self.posDir, entry: self.posEntry, stop: self.posStop, maxRR: self.maxTPLinesDrawn, maxPrice: self.posMaxPrice, entryBar: self.posEntryBar, exitBar: self.barIndex });
                        self.posDir = 0;
                        self.posEntry = undefined;
                        self.posStop = undefined;
                        self.posRisk = undefined;
                        self.posEntryBar = undefined;
                        self.posMaxPrice = undefined;
                        self.maxTPLinesDrawn = 0;
                    }
                    if (allowShort && self.posDir === 0) {
                        self.posDir = -1;
                        self.posEntry = self.latestSellAlertLow;
                        self.posStop = self.latestSellAlertHigh;
                        self.posRisk = Math.abs(self.posStop - self.posEntry);
                        self.posEntryBar = self.barIndex;
                        self.posMaxPrice = l;
                        self.maxTPLinesDrawn = 1;
                        self.buyEntryPlot = undefined;
                        //self.sellEntryPlot = self.posEntry;
                        self.sellSignalBar = self.barIndex;
                        self.sellEntryPlot = self.posEntry;
                        renderOverlay();
                        newSellEntry = true;
                        buyTrigger = false;
                        self.latestBuyAlertHigh = undefined;
                        self.latestBuyAlertLow = undefined;
                        self.latestBuyAlertBarIndex = undefined;
                        self.latestSellAlertHigh = undefined;
                        self.latestSellAlertLow = undefined;
                        self.latestSellAlertBarIndex = undefined;
                    }
                }
                if (self.posDir !== 0) {
                    if (self.posDir === 1)
                        self.posMaxPrice = Math.max(self.posMaxPrice != null ? self.posMaxPrice : h, h);
                    else
                        self.posMaxPrice = Math.min(self.posMaxPrice != null ? self.posMaxPrice : l, l);
                }
                const buySLHit = self.posDir === 1 && self.posStop != null &&
                    ((self.barIndex > self.posEntryBar && l <= self.posStop) ||
                        (self.barIndex === self.posEntryBar && c <= self.posStop));
                const sellSLHit = self.posDir === -1 && self.posStop != null &&
                    ((self.barIndex > self.posEntryBar && h >= self.posStop) ||
                        (self.barIndex === self.posEntryBar && c >= self.posStop));
                if (buySLHit || sellSLHit) {
                    // self.breakLineNextBar = true;
                    self.exitMarkerPlot = undefined;
                    f_draw_history_marker(self.posDir, self.posEntryBar, self.barIndex, self.posEntry, self.posStop, self.maxTPLinesDrawn, self.posMaxPrice);
                    // self.history.push({ dir: self.posDir, entry: self.posEntry, stop: self.posStop, maxRR: self.maxTPLinesDrawn, maxPrice: self.posMaxPrice, entryBar: self.posEntryBar, exitBar: self.barIndex });
                    if (typeof window !== "undefined") {
                        window.scalpxHistory = self.history;
                    }
                    sellTrigger = false;
                    self.posDir = 0;
                    self.posEntry = undefined;
                    self.posStop = undefined;
                    self.posRisk = undefined;
                    self.posEntryBar = undefined;
                    self.posMaxPrice = undefined;
                    self.maxTPLinesDrawn = 0;
                }
                if (self.posDir !== 0 && self.posRisk > 0) {
                    const curr_rr = self.posDir === 1 ? (h - self.posEntry) / self.posRisk : (self.posEntry - l) / self.posRisk;
                    let currentMaxTargetRR = self.maxTPLinesDrawn * rrStep;
                    while (curr_rr >= currentMaxTargetRR && self.maxTPLinesDrawn < MAX_TP_LINES) {
                        self.maxTPLinesDrawn += 1;
                        currentMaxTargetRR = self.maxTPLinesDrawn * rrStep;
                    }
                }
                if (self.latestBuyAlertBarIndex != null && (self.barIndex - self.latestBuyAlertBarIndex) > 7) {
                    self.latestBuyAlertHigh = undefined;
                    self.latestBuyAlertLow = undefined;
                    self.latestBuyAlertBarIndex = undefined;
                }
                if (self.latestSellAlertBarIndex != null && (self.barIndex - self.latestSellAlertBarIndex) > 7) {
                    self.latestSellAlertHigh = undefined;
                    self.latestSellAlertLow = undefined;
                    self.latestSellAlertBarIndex = undefined;
                }
                // if (buyAlertBar && !newBuyEntry) {
                //   self.latestBuyAlertHigh = h; self.latestBuyAlertLow = l; self.latestBuyAlertBarIndex = self.barIndex;
                // }
                // if (sellAlertBar && !newSellEntry) {
                //   self.latestSellAlertHigh = h; self.latestSellAlertLow = l; self.latestSellAlertBarIndex = self.barIndex;
                // }
                if (buyAlertBar && !newBuyEntry) {
                    self.latestBuyAlertHigh = h;
                    self.latestBuyAlertLow = l;
                    self.latestBuyAlertBarIndex = self.barIndex;
                }
                if (sellAlertBar && !newSellEntry) {
                    self.latestSellAlertHigh = h;
                    self.latestSellAlertLow = l;
                    self.latestSellAlertBarIndex = self.barIndex;
                }
                // let outEntry = null;
                // let breakLinesThisBar = false;
                // if (self.justReversed) {
                //     breakLinesThisBar = true;
                //     self.justReversed = false;
                // }
                let outBuyEntry = null;
                let outSellEntry = null;
                let outStop = null;
                const outTPs = new Array(MAX_TP_LINES).fill(null);
                // When posDir is 0 (no trade), outEntry/outStop/outTPs stay null.
                // This is what breaks the lines cleanly on the chart!
                // if (self.justReversed) {
                //     self.justReversed = false;
                //     renderOverlay();
                //     return [
                //         self.buyEntryPlot,
                //         self.sellEntryPlot,
                //         self.exitMarkerPlot,
                //         outBuyEntry,
                //         outSellEntry,
                //         null,
                //         null,
                //         ...new Array(MAX_TP_LINES).fill(null)
                //     ];
                // }
                if (self.posDir !== 0 && self.posEntry != null) 
                //if (!breakLinesThisBar && self.posDir !== 0 && self.posEntry != null)
                {
                    // if (showEntry && !breakLinesThisBar)
                    // {
                    if (showEntry) {
                        if (self.posDir === 1) {
                            outBuyEntry = self.posEntry;
                        }
                        if (self.posDir === -1) {
                            outSellEntry = self.posEntry;
                        }
                    }
                    // if (showEntry) outEntry = self.posEntry;
                    if (showSL && self.posStop != null)
                        outStop = self.posStop;
                    if (showTP && self.posRisk > 0 && rrStep > 0) {
                        const calcTP = (level) => self.posDir === 1
                            ? self.posEntry + (self.posRisk * level * rrStep)
                            : self.posEntry - (self.posRisk * level * rrStep);
                        for (let i = 1; i <= Math.min(MAX_TP_LINES, self._max_targets); i++) {
                            outTPs[i - 1] = calcTP(i);
                        }
                    }
                }
                renderOverlay();
                if (self.breakPreviousTradeOnly) {
                    self.breakPreviousTradeOnly = false;
                    return [
                        self.buyEntryPlot,
                        self.sellEntryPlot,
                        self.exitMarkerPlot,
                        null,
                        null,
                        null,
                        ...new Array(MAX_TP_LINES).fill(null)
                    ];
                }
                return [
                    self.buyEntryPlot,
                    self.sellEntryPlot,
                    self.exitMarkerPlot,
                    outBuyEntry,
                    outSellEntry,
                    outStop,
                    ...outTPs
                ];
            };
            if (typeof window !== "undefined" && window.tvWidget) {
                if (!window._scalpx_listener_added) {
                    window._scalpx_listener_added = true;
                    try {
                        window.tvWidget.subscribe("study_event", (entityId, studyEventType) => {
                            if (studyEventType === "remove") {
                                const studies = window.tvWidget.activeChart().getAllStudies();
                                const present = !!studies.find(s => s.name === "ScalpX Pro");
                                if (!present) {
                                    const el = document.getElementById(OVERLAY_ID);
                                    if (el)
                                        el.remove();
                                }
                            }
                        });
                    }
                    catch (e) { /* ignore */ }
                }
            }
        }
    };
}
export default ScalpXIndicator;
